import React, { useEffect } from 'react';
import { ProductInfoPage } from '../components/ProductInfoPage';

export default function TestingSandbox() {
  useEffect(() => {
    let pageHtml: string | null = null;
    const loop = setInterval(() => {
      fetch('/test/')
        .then((r) => r.text())
        .then((body) => {
          if (pageHtml == null) {
            pageHtml = body;
          } else {
            if (pageHtml != body) {
              window.location.reload();
            }
          }
        });
    }, 1000);
    return () => clearInterval(loop);
  }, []);
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <ProductInfoPage ean_code={'1234'} eventName="scan" showPollButton={true} />
    </div>
  );
}
